import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { QueryEnrollmentRequest, UploadDniRequest, UploadFaceRequest, FinishEnrollmentRequest, QueryEnrollmentResponse, IdNowCommonResponse, InitEnrollmentRequest } from './idnow-backend-services-domain';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { NotificationService } from './notification.service';

@Injectable({
  providedIn: 'root'
})
export class IdnowBackendsService {
    public hostLocal = 'http://192.168.8.102:7001';
    
    public hostFinal = 'https://idnowconsole.ticnow.cl';

    private host = this.hostFinal;
  
    constructor(
       private httpWeb: HttpClient,
       private ngxLoader: NgxUiLoaderService,
       private notifyService : NotificationService
    ) { }

    initOOBEnrollment(userId: string, uuidDevice: string, onSuccess?: Function, onError?: Function) {
        this.ngxLoader.start();
        const initEnrollmentRequest = InitEnrollmentRequest.buildTuyaRequest(userId, uuidDevice);

        this.httpWeb.post(this.host + '/id-now-services/api/v3/mobile-hub/enrollment/initOOBEnrollment', 
            initEnrollmentRequest, this.buildOptions()).subscribe(data => {

            const response = data as unknown as QueryEnrollmentResponse;

            if(response.code == '00'){
                this.saveUuidTransaction(response.uuidTransaction);
                if (onSuccess) onSuccess(response);
            } else {
                console.error('Error en el servicio: ', response);
                this.notifyService.showError("Lo lamentamos, no hemos podido realizar su petición", "Error")
                if (onError) onError();
            }

            this.ngxLoader.stop();
        }, error => {
            if (onError) onError(error);

            this.ngxLoader.stop();
        });
    }
    
    queryOOBEnrollment(uuidTransaction: string, onSuccess?: Function, onError?: Function) {
        this.ngxLoader.start();
        let request = QueryEnrollmentRequest.buildTuyaRequest(uuidTransaction);

        this.httpWeb.post(this.host + '/id-now-services/api/v3/mobile-hub/enrollment/queryOOBEnrollment', 
                request, this.buildOptions()).subscribe(data => {
            const response = data as unknown as QueryEnrollmentResponse;
            
            if(response.code == '00'){
                this.saveBaseResponse(response);

                if (onSuccess) onSuccess(response);
            } else {
                console.error('Respuesta del servicio: ',response);
                this.notifyService.showError("Lo lamentamos, el vinculo de enrolamiento no es válido", "Error");

                if (onError) onError();
            }

            this.ngxLoader.stop();
        }, error => {
            if (onError) onError(error);

            this.ngxLoader.stop();
        });
    }

    analizeDni(base64FrontDni: any, base64BackDni: any, onSuccess?: Function, onError?: Function){
        this.ngxLoader.start();
        const baseResponse = this.getBaseResponse();
        const uploadDniRequest = UploadDniRequest.buildTuyaRequest(baseResponse, base64FrontDni, base64BackDni);

        this.httpWeb.post(this.host + '/id-now-services/api/v3/mobile-hub/enrollment/finalAnalizeDniB64', 
                uploadDniRequest, this.buildOptions()).subscribe(data => {
            const dniResponse = data as unknown as IdNowCommonResponse;

            if( dniResponse.code == '00' ){
                this.saveDniData(dniResponse);
                this.notifyService.showSuccess("Hemos procesado su documento", "Informacion");
                
                if (onSuccess) onSuccess(data);
            } else {
                if(dniResponse.code == '33'){
                    this.notifyService.showError("Lo lamentamos, no pudimos llevar a cabo su enrolamiento", "Error");
                } else {
                    this.notifyService.showWarning("Ha ocurrido un error en la lectura, intente nuevamente (" + dniResponse.description + ")", "Error");
                }

                console.error('Respuesta del servicio: ', dniResponse);
                if (onError) onError();
            }
            
            this.ngxLoader.stop();
        }, error => {
            if (onError) onError(error);

            this.ngxLoader.stop();
        });
    }

    finalMatchFace(onSuccess?: Function, onError?: Function) {
        this.ngxLoader.start();

        const uploadFace: UploadFaceRequest = this.getUploadFaceRequest();
        uploadFace.base64Face = this.getBase64Face().replace('data:image/jpeg;base64,','');

        this.httpWeb.post(this.host + '/id-now-services/api/v3/mobile-hub/enrollment/finalMatchFaceB64', 
                uploadFace, this.buildOptions()).subscribe(data => {
            const selfieResponse = data as unknown as IdNowCommonResponse;

            if(selfieResponse.code == '00'){
                this.notifyService.showSuccess("Hemos procesado su imagen facial", "Informacion");
    
                if (onSuccess) onSuccess(uploadFace);
            } else {
                console.error('Respuesta del servicio: ', selfieResponse);

                if (onError) onError();
            }

            this.ngxLoader.stop();
        }, error => {
            if (onError) onError(error);

            this.ngxLoader.stop();
        });
    }

    finishEnrollment(uploadFaceRequest: UploadFaceRequest, onSuccess?: Function, onError?: Function) {
        this.ngxLoader.start();
        let finishEnrollmentRequest = FinishEnrollmentRequest.buildTuyaRequest(uploadFaceRequest);

        this.httpWeb.post(this.host + '/id-now-services/api/v3/mobile-hub/enrollment/finishEnrollment', 
            finishEnrollmentRequest, this.buildOptions()).subscribe(data => {
            let response = data as unknown as IdNowCommonResponse;

            if(response.code = '00'){
                if (onSuccess) onSuccess(data);
            }else{
                console.error('Respuesta del servicio: ', response);
                if (onError) onError();
            }

            this.ngxLoader.stop();
        }, error => {
            if (onError) onError(error);

            this.ngxLoader.stop();
        });
    }

    private buildOptions(): any {
        /* Volver a colocar las credenciales de TUYA
        let headers = new HttpHeaders({
            'API-USER': 'TUYA',
            'API-KEY': '9f0aa873-d6f6-4aa8-9b79-4720142dfe31' });*/
        let headers = new HttpHeaders({
            'API-USER': 'RIPLEY CHI',
            'API-KEY': '9f0aa873-d6f6-4aa8-9b79-4720142dfe31' });
        return { headers: headers };
    }

    public getIPAddress()  {  
        return this.httpWeb.get("https://cors-anywhere.herokuapp.com/http://api.ipify.org/?format=json");  
    }

    // Estos metodos deberian ser parametros pasados entre componentes?
    private saveBaseResponse(baseResponse: QueryEnrollmentResponse) {
        localStorage.setItem('baseResponse', JSON.stringify(baseResponse));
    }
    public getBaseResponse(): QueryEnrollmentResponse {
        return JSON.parse(localStorage.getItem('baseResponse'));
    }

    private saveDniData(dniData: IdNowCommonResponse) {
        localStorage.setItem('dniData', JSON.stringify(dniData));
    }
    public getDniData(): IdNowCommonResponse {
        return JSON.parse(localStorage.getItem('dniData'));
    }

    private saveUploadFaceRequest(uploadFaceRequest: any) {
        localStorage.setItem('uploadFaceRequest', JSON.stringify(uploadFaceRequest));
    }
    public getUploadFaceRequest(): any {
        return JSON.parse(localStorage.getItem('uploadFaceRequest'));
    }

    private saveBase64Face(base64Face: any) {
        localStorage.setItem('base64Face', JSON.stringify(base64Face));
    }
    public getBase64Face(): string {
        return localStorage.getItem('base64Face');
    }
    private saveUuidTransaction(uuidTransaction: any) {
        localStorage.setItem('uuidTransaction', JSON.stringify(uuidTransaction));
    }
    public getUuidTransaction(): string {
        return localStorage.getItem('uuidTransaction');
    }
}
